import { FASTElement, attr, customElement, observable } from '@microsoft/fast-element';
import { CompanyApproveStyles as styles } from './company-approval.styles';
import { CompanyApprovalTemplate as template } from './company-approval.template';
import { ICompanyApproval } from '../../../types';
import { formatDateForInput } from '../../../utils/formatting';
import { GOVERNING_AGREEMENT } from "../../../utils";

const name = 'company-approval';

@customElement({
  name,
  template,
  styles,
})
export class CompanyApproval extends FASTElement {
  @attr approval: ICompanyApproval;

  @observable isCheckedChanged: boolean = false;
  @observable showDateChanged: boolean = false;

  @observable isCompanyApproval: boolean;
  @observable governingAgreement: GOVERNING_AGREEMENT;
  @observable effectiveDate: any;

  async connectedCallback() {
    super.connectedCallback();
    this.isCompanyApproval = this.approval.IS_CHECKED;
    // this.isCompanyApprovalChanged();
    this.governingAgreement = this.approval.GOVERNING_AGREEMENT;
    // this.governingAgreementChanged();
    this.effectiveDate = formatDateForInput(this.approval.EFFECTIVE_DATE as number);
    // this.effectiveDateChanged();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  isCompanyApprovalChanged() {
    const value = this.isCompanyApproval;
    this.isCheckedChanged = value;
    this.showDateChanged =
      this.isCheckedChanged &&
      this.governingAgreement == GOVERNING_AGREEMENT.EXISTING_ISDA_MASTER_AGREEMENT;
    this.approval.IS_CHECKED = value;
    this.$emit('approvalAdded', this.approval as ICompanyApproval);
  }

  governingAgreementChanged() {
    this.approval.GOVERNING_AGREEMENT = this.governingAgreement;
    this.showDateChanged =
      this.isCheckedChanged &&
      this.governingAgreement == GOVERNING_AGREEMENT.EXISTING_ISDA_MASTER_AGREEMENT;
    if (this.governingAgreement == GOVERNING_AGREEMENT.STANDALONE_VPPA) {
      this.effectiveDate = null;
    }
    this.$emit('approvalAdded', this.approval as ICompanyApproval);
  }

  effectiveDateChanged() {
    this.approval.EFFECTIVE_DATE = this.effectiveDate
      ? new Date(this.effectiveDate).getTime()
      : null;
    this.$emit('approvalAdded', this.approval as ICompanyApproval);
  }

  private CASCADE_COMPANY_NAME_MAX_SIZE: number = 18;

  getCompanyName() {
    return this.approval.CASCADE_COMPANY_NAME.length >= this.CASCADE_COMPANY_NAME_MAX_SIZE
      ? `${this.approval.CASCADE_COMPANY_NAME.substring(0, this.CASCADE_COMPANY_NAME_MAX_SIZE)}...`
      : this.approval.CASCADE_COMPANY_NAME;
  }
}
